export default __webpack_public_path__ + "static/media/horeca_icon.15c9932b.svg";